import { Button, Form, Image, Accordion, OverlayTrigger, Tooltip } from "react-bootstrap";
import questionsData from "@/lib/industryQuestions.json";
import { useCallback, useRef, useState } from "react";
import { useRouter } from "next/router";
import { useAppDispatch, useAppSelector } from "@/lib/redux/store";

export default function Page()
{
    const [getSelectedQuestion, setSelectedQuestion] = useState("Mental Health Industry");
    const [getMatchedData, setMatchedData] = useState([]);
    const router = useRouter();
    const dispatch = useAppDispatch();
    const store = useAppSelector((state) => state.app);
    const { roleActingAs } = store;
    const entitySlug = roleActingAs?.entity?.slug;
    const targetRef = useRef(null);

    const selectedQuestions = (selectedObj) =>
    {
        if (targetRef.current)
        {
            targetRef.current.scrollIntoView({
                behavior: "smooth", 
                block: "center",    
                inline: "nearest"   
            });
        }
 
        setSelectedQuestion(selectedObj);
        const matchedObj = Object.keys(questionsData).find(
            (item) => item.trim().toLowerCase() === selectedObj.trim().toLowerCase()
        );
        if (matchedObj)
        {
            setMatchedData(matchedObj);
        } else
        {
            setMatchedData([]);
        }
    };

    const selectedAnswer = useCallback((selectedAns) =>
    {
        dispatch({ type: 'app/setJsonPollQuestion', payload: selectedAns });
        router.push(`/${entitySlug}/polls/create`);
    }, [dispatch, entitySlug, router]);

    const [activeKey, setActiveKey] = useState(null);

    const handleToggle = (key) =>
    {
        setActiveKey(activeKey === key ? null : key);
    };

    return (
        <section className="row bg-white rounded p-4 ms-0 me-2">
            <div className="col-12 mb-5">
                <h1>Leadership isn’t about having all the answers— it’s about asking the right questions.</h1>
            </div>
            <div className="industry">
                <div className="row">
                    {[
                        { label: "Mental Health Industry", img: "/industry/mental-health-industry-polling.png" },
                        { label: "Mental Health FIFO", img: "/industry/mental-health-fifo-polling.png" },
                        { label: "Executive Leadership", img: "/industry/executive-leadership-polling.png" },
                        { label: "High Performing Team - MGT", img: "/public/high-performing-team-polling.png" },
                        { label: "Vision & Strategy", img: "/industry/education-polling-category.png" },
                        { label: "Customer Market & Focus", img: "/public/workplace-culture-polling.png" },
                        { label: "Growth & Scaling", img: "/public/business-growth-polling-background.png" },
                        { label: "Innovation & Future Trends", img: "/public/innovation-trends-polling.png" },
                        { label: "Resilience & Adaptability", img: "/industry/healthcare-polling-category.png" },
                        { label: "Technology & Digital", img: "/industry/government-polling-category.png" },
                        { label: "Financial & Operational Excellence", img: "/industry/events-polling-category.png" },
                        { label: "Sustainability & Purpose", img: "/industry/consultants-polling-category.png" },
                        { label: "Workplace Culture", img: "/public/workplace-culture-polling.png" },
                    ].map((item, index) => (
                        <div key={index} className="col-6 col-sm-4 col-md-2 col-lg-2 mb-3 col-lg-custom">
                            <div className="cursorPointer" onClick={() => selectedQuestions(item.label)}>
                                <div className="industry-card-new shadow text-center">
                                    <Image
                                        src={item.img}
                                        alt={item.label}
                                        className="questionImagesadmin"
                                        width={100}
                                        height={100}
                                    />
                                    <div
                                        className={
                                            getSelectedQuestion === item.label
                                                ? "question-footer-selected"
                                                : "question-footer text-white"
                                        }
                                    >
                                        {item.label}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Accordion Section */}
            <div className="answerSection mt-5" ref={targetRef} >
                <h2 className="fw-bold mb-4 highlightedColor hoverEffects">{getSelectedQuestion}</h2>
                {(getSelectedQuestion === 'Mental Health Industry' || getSelectedQuestion === 'Mental Health FIFO') && (
                    <h4 className="fw-bold mb-4 highlightedColor hoverEffects">Author: {questionsData[getSelectedQuestion]?.find(item => item.author)?.author}</h4>
                )}
                {getMatchedData ? (
                    <div className="mb-4 pb-3">
                        {(() =>
                        {
                            const questions = questionsData[getSelectedQuestion] || [];
                            const grouped = questions.reduce((acc, item) =>
                            {
                                const key = item.subheading;
                                if (!acc[key]) acc[key] = [];
                                acc[key].push(item);
                                return acc;
                            }, {});

                            return (

                                <Accordion>
                                    {Object.keys(grouped).map((subheading, index) =>
                                    {
                                        const meta = grouped[subheading].find(
                                            (item) => item.author || item.desc
                                        );

                                        return (
                                            <Accordion.Item eventKey={index.toString()} key={subheading}>

                                                <Accordion.Header
                                                    onClick={() => handleToggle(index.toString())}
                                                    className="customAccordionHeader d-flex justify-content-between align-items-center"
                                                >
                                                    <div className="d-flex align-items-center gap-2">
                                                        {(getSelectedQuestion === "Executive Leadership" ||
                                                            getSelectedQuestion === "Workplace Culture") && (
                                                                <span>Author:</span>
                                                            )}

                                                        <span>{subheading}</span>
                                                    </div>
                                                    {(getSelectedQuestion === "Mental Health Industry" ||
                                                        getSelectedQuestion === "Mental Health FIFO") && (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-${index}`}>
                                                                        {meta?.desc}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span
                                                                    onClick={(e) => e.stopPropagation()}

                                                                >
                                                                    <i className="bi bi-info-circle-fill secondaryColor ms-2 font24"></i>
                                                                </span>
                                                            </OverlayTrigger>
                                                        )}
                                                </Accordion.Header>

                                                <Accordion.Body>
                                                    {grouped[subheading].map((item, idx) => (
                                                        <div key={idx} className="mb-4 container">
                                                            <h6 className="fw-bold mb-3 secondaryColor">
                                                                {item.question}
                                                            </h6>

                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <Form className="ms-2 flex-grow-1">
                                                                    {item.options?.map((opt, optIdx) => (
                                                                        <div key={optIdx} className="d-flex align-items-center mb-2">
                                                                            <Form.Check.Input
                                                                                type="checkbox"
                                                                                disabled
                                                                                className="custom-blue-checkbox"
                                                                            />
                                                                            <span className="ms-2">{opt}</span>
                                                                        </div>
                                                                    ))}
                                                                </Form>

                                                                <Button
                                                                    variant="primary"
                                                                    className="ms-3 rounded-pill px-4 fitContent"
                                                                    onClick={() => selectedAnswer(item)}
                                                                >
                                                                    Select
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        );
                                    })}
                                </Accordion>
                            );
                        })()}
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </section >
    );
}

Page.layout = "admin";